import { render, staticRenderFns } from "./DepartAreaManage.vue?vue&type=template&id=58f7ffd0&"
import script from "./DepartAreaManage.vue?vue&type=script&lang=js&"
export * from "./DepartAreaManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports